import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Modal } from 'react-bootstrap';
import AudioPlayer from '../../../components/AudioPlayer';

const isSearch = false;

const Greetings = ({
  setOpenModal,
  openModal,
  greetingData,
  setGreetingData,
}) => {
  const handleClose = () => {
    setOpenModal(false);
    setGreetingData([]);
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={openModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Greetings</h5>
        </div>
        <div className="body-content-outer modal-body flex-column">
          <div className="list_container w-100">
            {isSearch && (
              <div className="list_search">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="list_search_icon"
                  color="#c4d4d9"
                />
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search..."
                />
              </div>
            )}
            <div
              className={`list_header d-flex w-100 justify-content-between ${
                isSearch ? '' : 'border-radius-5'
              } bottom-left-radius-5 bottom-right-radius-5`}
            >
              <div className="list_header_group w-85"> DID Number</div>
              <div className="list_header_group w-15"> Greeting</div>
            </div>
            <div className="list_body">
              {greetingData?.length > 0
                ? greetingData.map(({ greeting_url, did_number }) => (
                    <div className="list_row_group d-flex w-100 justify-content-between">
                      <div className="list_row w-85">{did_number}</div>
                      <div className="list_row w-15">
                        <AudioPlayer url={greeting_url} />
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Greetings;
